module.exports = __webpack_public_path__ + "static/img/user_option_bg.beaf202.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/user_option_bg.png
// module id = JDf+
// module chunks = 0